const InvestmentPlanTax = {
  label: 'Recommended Investment Plans',
  sections: [
    {
      type: 'text',
      text: "<br><h5>Here's our recommended plan for you.</h5>",
    },
    {
      type: 'cards',
      cards: [
        {
          title: 'Growth with Tax Savings',
          returns: '14.9',
          doubledIn: `Lowest lock-in period of 3 years compared to FD / PPF.`,
          link: '/save/plan/19',
          highlighted: true,
          planId: 19,
        },
      ],
    },
    {
      type: 'text',
      text: () => {
        return `<br/>
        <small class="light">
          Don't delay, finish your tax savings in a few minutes.
        </small>`;
      },
    },
  ],
};

export default InvestmentPlanTax;



// WEBPACK FOOTER //
// ./components/recommendation/cards/investmentPlanTax.ts